import type { QueryFunctionContext } from '@tanstack/react-query';
import type { KyInstance } from 'ky';

/**
 * Convenience wrapper for TanStack `queryFn` context.
 *
 * Reads the QueryClient's *default* query meta rather than `context.meta`: a query that declares its
 * own `meta` (as the session query does) shadows the client default entirely, so per-call `meta`
 * cannot be relied on to carry `http`. Going through the defaults also stops call sites from
 * swapping the client out.
 */
export function getHttpFromQueryFnContext(context: Pick<QueryFunctionContext, 'client'>): KyInstance {
  const http = context.client.getDefaultOptions().queries?.meta?.http;
  if (!http) {
    throw new Error('Missing QueryClient default meta.http. Create the client with createQueryClient(http).');
  }

  return http;
}
